// extracted by mini-css-extract-plugin
export default {"container":"Selection-module__container__uRQcanH","checkbox":"Selection-module__checkbox__xSfFSUp"};